import { Grid } from 'gridjs-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoanModal = ({ isOpen, onClose, title, data, columns }) => {
  if (!isOpen) return null;
  const navigate = useNavigate()

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`} onClick={onClose}></div>

      <div className="flex items-center justify-center min-h-screen p-4">
        <div className={`relative w-full max-w-4xl max-h-full bg-white rounded-lg shadow-lg transform transition-all duration-300 ${isOpen ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
          
          {/* Modal Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h5 className="text-xl font-semibold text-gray-800">
              {title}
            </h5>
            <button
              type="button"
              className="text-gray-400 hover:text-gray-900"
              onClick={() => {onClose, navigate('/admin/loans-payment')}}
            >
              <i className='mgc_close_line'></i>
            </button>
          </div>

          {/* Modal Body (Isi Tabel) */}
          <div className="p-4 overflow-x-auto">
            <Grid
              data={data}
              columns={columns}
            />
          </div>
          
          {/* Modal Footer (opsional) */}
          <div className="flex justify-end p-4 border-t border-gray-200">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {onClose, navigate('/admin/loans-payment')}}
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanModal;